import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { AuthGuard } from './_helpers';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard/default',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./demo/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'basic',
        loadChildren: () => import('./demo/ui-elements/ui-basic/ui-basic.module').then(m => m.UiBasicModule)
      },
      {
        path: 'forms',
        loadChildren: () => import('./demo/pages/form-elements/form-elements.module').then(m => m.FormElementsModule)
      },
      {
        path: 'tables',
        loadChildren: () => import('./demo/pages/tables/tables.module').then(m => m.TablesModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./demo/pages/core-chart/core-chart.module').then(m => m.CoreChartModule)
      },
      {
        path: 'sample-page',
        loadChildren: () => import('./demo/extra/sample-page/sample-page.module').then(m => m.SamplePageModule)
      },
      //nttthuy add 26/03/2020
      {
        path: 'danhmuc',
        loadChildren: () => import('./quanlythongtin/danhmuc/danhmuc.module').then(m => m.DanhmucModule)
      },
      //Long
      {
        path: 'system',
        loadChildren: () => import('./system/system.module').then(m => m.SystemModule)
      },
      {
        path: 'cauhoi',
        loadChildren: () => import('./quanlythongtin/cauhoithamdo/cauhoithamdo.module').then(m => m.CauhoithamdoModule)

      },
      {
        path: 'pakn',
        loadChildren: () => import('./quanlythongtin/phananhkiennghi/phananhkiennghi.module').then(m => m.PhananhkiennghiModule)
      },
      {
        path: 'dmtthc',
        loadChildren: () => import('./quanlythongtin/thutuchanhchinh/thutuchanhchinh.module').then(m => m.ThutuchanhchinhModule)
      },
      {
        path: 'gqdtkntc',
        loadChildren: () => import('./quanlythongtin/giaiquyetdonthukntc/giaiquyetdonthukntc.module').then(m => m.GiaiquyetdonthukntcModule)
      },
      {
        path: 'duankeugoi',
        loadChildren: () => import('./quanlythongtin/duankeugoi/duankeugoi.module').then(m => m.DuankeugoiModule)
      },
      {
        path: 'danhmucvb',
        loadChildren: () => import('./quanlyvanban/danhmuc/danhmuc.module').then(m => m.DanhmucModule)
      },
      {
        path: 'qlvanban',
        loadChildren: () => import('./quanlyvanban/quanlyvanban/quanlyvanban.module').then(m => m.QuanlyvanbanModule)
      },
      {
        path: 'qltttcd',
        loadChildren: () => import('./quanlythongtin/tiepcongdan/tiepcongdan.module').then(m => m.TiepcongdanModule)
      },
      {
        path: 'qlttlh',
        loadChildren: () => import('./quanlythongtin/quanlylichhop/quanlylichhop.module').then(m => m.QuanlylichhopModule)
      },
      {
        path: 'lienhe',
        loadChildren: () => import('./quanlythongtin/lienhe/lienhe.module').then(m => m.LienheModule)
      },
      {
        path: 'hoidaptt',
        loadChildren: () => import('./quanlythongtin/hoidaptt/hoidaptt.module').then(m => m.HoidapttModule)
      },
      {
        path: 'qltthoidap',
        loadChildren: () => import('./quanlythongtin/hoidap/hoidap.module').then(m => m.HoidapModule)
      },
      {
        path: 'danhmucdetai',
        loadChildren: () => import('./thongtindetai/danhmuc/danhmuc.module').then(m => m.DanhmucModule)
      },
      {
        path: 'thongtindetai',
        loadChildren: () => import('./thongtindetai/detai/detai.module').then(m => m.DetaiModule)
      },
      {
        path: 'qlttcongkhaingansach',
        loadChildren: () => import('./quanlythongtin/congkhaingansach/congkhaingansach.module').then(m => m.CongkhaingansachModule)
      },
      {
        path: 'diendan',
        loadChildren: () => import('./quanlyvanban/diendancutri/diendancutri.module').then(m => m.DiendancutriModule)
      }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then(m => m.AuthenticationModule)
      },
      {
        path: 'thutuchanhchinh',
        loadChildren: () => import('./quanlythongtin/thutuchanhchinh/thutuchanhchinh.module').then(m => m.ThutuchanhchinhModule)
      },
      {
        path: 'lichhop',
        loadChildren: () => import('./quanlythongtin/quanlylichhop/quanlylichhop.module').then(m => m.QuanlylichhopModule)
      },
      {
        path: 'ttdetai',
        loadChildren: () => import('./thongtindetai/detai/detai.module').then(m => m.DetaiModule)
      },
      {
        path: 'lichtiepdan',
        loadChildren: () => import('./quanlythongtin/tiepcongdan/tiepcongdan.module').then(m => m.TiepcongdanModule)
      },
      {
        path: 'doithoai',
        loadChildren: () => import('./quanlythongtin/hoidaptt/hoidaptt.module').then(m => m.HoidapttModule)
      },
      {
        path: 'thongtinvanban',
        loadChildren: () => import('./quanlyvanban/quanlyvanban/quanlyvanban.module').then(m => m.QuanlyvanbanModule)
      },
      {
        path: 'cauhoithamdo',
        loadChildren: () => import('./quanlythongtin/cauhoithamdo/cauhoithamdo.module').then(m => m.CauhoithamdoModule)
      },
      {
        path: 'hoidap',
        loadChildren: () => import('./quanlythongtin/hoidap/hoidap.module').then(m => m.HoidapModule)
      },
      {
        path: 'thongtinlienhe',
        loadChildren: () => import('./quanlythongtin/lienhe/lienhe.module').then(m => m.LienheModule)
      },
      {
        path: 'congkhaingansach',
        loadChildren: () => import('./quanlythongtin/congkhaingansach/congkhaingansach.module').then(m => m.CongkhaingansachModule)
      },
      {
        path: 'duthaovbqppl',
        loadChildren: () => import('./quanlyvanban/quanlyvanban/quanlyvanban.module').then(m => m.QuanlyvanbanModule)
      },
      {
        path: 'diendancutri',
        loadChildren: () => import('./quanlyvanban/diendancutri/diendancutri.module').then(m => m.DiendancutriModule)
      },
      {
        path: 'duandautu',
        loadChildren: () => import('./quanlythongtin/duankeugoi/duankeugoi.module').then(m => m.DuankeugoiModule)
      },
      {
        path: 'phananhkiennghi',
        loadChildren: () => import('./quanlythongtin/phananhkiennghi/phananhkiennghi.module').then(m => m.PhananhkiennghiModule)
      },
      {
        path: 'vanbanketluatgqdtkntc',
        loadChildren: () => import('./quanlythongtin/giaiquyetdonthukntc/giaiquyetdonthukntc.module').then(m => m.GiaiquyetdonthukntcModule)
      },
      {
        path: 'changepw',
        loadChildren: () => import('./theme/layout/admin/nav-bar/pw-change/pw-change.module').then(m => m.PwChangeModule)
      },
      {
        path: 'personalinfor',
        loadChildren: () => import('./theme/layout/admin/nav-bar/personalinfor/personalinfor.module').then(m => m.PersonalinforModule)
      },
      {
        path: 'layouttruycap/:madv',
        loadChildren: () => import('./layouttruycap/layouttruycap.module').then(m => m.LayouttruycapModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
